import { Component, OnInit } from '@angular/core';
import { InteractorService } from 'src/app/core/services/interactor.service';

@Component({
  selector: 'app-assessment-email-summary',
  templateUrl: './assessment-email-summary.component.html',
  styleUrls: ['./assessment-email-summary.component.scss']
})
export class AssessmentEmailSummaryComponent implements OnInit {
  public isShowCard = false;
  public showDetails = false;
  brandingDetails = JSON.parse(localStorage.getItem('branding'));
  insertColor=this.brandingDetails?.branding?.BackgroundColors?.InsertColor;
  currentCard=this.brandingDetails?.branding?.BackgroundColors?.CurrentCardBackground;
  constructor(private interactorService: InteractorService) {

  }

  ngOnInit(): void {
    this.interactorService.brandingDetailsCast.subscribe(data => {
      if (data) {
        this.brandingDetails = data;
        document.documentElement.style.setProperty('--insertColor', this.brandingDetails?.branding?.BackgroundColors?.InsertColor);
        document.documentElement.style.setProperty('--currentCard', this.brandingDetails?.branding?.BackgroundColors?.CurrentCardBackground);
      }
      this.setBackgroundColors();
    });
    document.documentElement.style.setProperty('--insertColor', this.brandingDetails?.branding?.BackgroundColors?.InsertColor);
    document.documentElement.style.setProperty('--currentCard', this.brandingDetails?.branding?.BackgroundColors?.CurrentCardBackground);
  }

  showCard() {
    this.isShowCard = true;
  }

  hideCard() {
    this.isShowCard = false;
  }

  openTabs() {
    if (this.showDetails === false) {
      this.showDetails = true;
    } else if (this.showDetails === true) {
      this.showDetails = false;
    }
  }
  setBackgroundColors(){
    this.insertColor=this.brandingDetails?.branding?.BackgroundColors?.InsertColor;
    this.currentCard=this.brandingDetails?.branding?.BackgroundColors?.CurrentCardBackground;
  }


}
